import script from "./form-name.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-name.vue?vue&type=script&setup=true&lang=ts"

import "./form-name.vue?vue&type=style&index=0&id=bbfba3d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbfba3d6"]])

export default __exports__